const CardPic = ({ imgSrc, imgAlt }) => {
  return (
    <div className="">
      <img src={imgSrc} alt={imgAlt} />
    </div>
  );
};
export default CardPic;
